import React, { useContext } from "react";
import DiscountTable from "./DiscountTable";
import { NavLink } from "react-router-dom";
import { Button, Space } from "antd";
import { context } from "../../context/context";

const Discounts = () => {
    // context
    const {
        setDiscountCover,
        setDiscountCoverId,
        setDiscountDescription,
        setDiscountLinkTitle,
        setDiscountLinkUrl,
        setDiscountLinks,
        setDiscountMedia,
        setDiscountMediaId,
        setDiscountTags,
        setDiscountTitle,
    } = useContext(context);
    // functions
    const handleEmptyStates = () => {
        setDiscountCover();
        setDiscountCoverId();
        setDiscountDescription();
        setDiscountLinkTitle();
        setDiscountLinkUrl();
        setDiscountLinks([]);
        setDiscountMedia([]);
        setDiscountMediaId([]);
        setDiscountTags([]);
        setDiscountTitle();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addDiscount">
                    <Button onClick={handleEmptyStates} type="primary">
                        اضافه کردن تخفیف جدید
                    </Button>
                </NavLink>
            </Space>
            <DiscountTable />
        </>
    );
};

export default Discounts;
